<!--
 * @Date: 2021-04-29 08:01:49
 * @LastEditors: natsu
 * @LastEditTime: 2021-05-12 08:03:21
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>xlsx</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/xlsx/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "0.16.9",
          linkList: [ur + "0.16.9/xlsx.mini.js", ur + "0.16.9/patches/xlsx.mini.js"]
        },
        {
          label: "0.15.5",
          linkList: [ur + "0.15.5/xlsx.mini.min.js"]
        },
        {
          label: "0.14.1",
          linkList: [ur + "0.14.1/xlsx.mini.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListXlsx.vue